<div class="textarea-container">
    <field-config-base #base [config]="config" [dataType]="dataType"></field-config-base>
</div>
